import { Fragment } from 'react';
import styles from './DatePicker.module.scss';
import {
  DatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';

import { createTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import { MuiPickersOverrides } from '@material-ui/pickers/typings/overrides';
import OverwriteMomentBE from '../../services/picker/OverwriteMomentBE';
import moment from 'moment';
type overridesNameToClassKey = {
  [P in keyof MuiPickersOverrides]: keyof MuiPickersOverrides[P];
};
declare module '@material-ui/core/styles/overrides' {
  export interface ComponentNameToClassKey
    extends overridesNameToClassKey {}
}

interface IProps {
  style?: {};
  placeholder?: string;
  value: any;
  minDate?: Date;
  disabled?: boolean;
  onChange: (event: any) => void;
}

const MUIDatePicker: React.FC<IProps> = (props: IProps) => {
  const theme = createTheme({
    palette: {
      primary: {
        main: '#0052cc',
      },
      secondary: {
        main: '#edf2ff',
      },
    },
  });

  return (
    <>
      <ThemeProvider theme={theme}>
        <MuiPickersUtilsProvider
          utils={OverwriteMomentBE}
          locale="th"
        >
          <Fragment>
            <DatePicker
              style={props.style}
              className={styles.datePicker}
              placeholder={props.placeholder}
              minDate={props.minDate || moment().add(0, 'days')}
              disabled={props.disabled || false}
              format="DD/MM/yyyy"
              views={['year', 'month', 'date']}
              value={props.value || moment().add(1, 'days')}
              onChange={props.onChange}
            />
          </Fragment>
        </MuiPickersUtilsProvider>
      </ThemeProvider>
    </>
  );
};

export default MUIDatePicker;
